import { useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import { BasicInput } from "../../../components/BasicInput";
import { Button } from "../../../components/ui/button";
import { cpfMask } from "../../../../app/utils/cpfFormater";
import { phoneMask } from "../../../../app/utils/phoneFormater";
import { useStepValidation } from "../components/useStepValidation";
import { RegisterFormData } from "../components/types";

interface PersonalInformationProps {
  onNext: () => void;
}

const PersonalInformation = ({ onNext }: PersonalInformationProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<RegisterFormData>();
  const isValid = useStepValidation("personal-information");

  const onSubmit = () => {
    onNext();
  };

  return (
    <div className="flex flex-col gap-4 sm:gap-6 text-black03">
      <div className="text-center sm:text-left">
        <h2 className="text-xl sm:text-2xl font-semibold">Informações Pessoais</h2>
        <p className="text-xs sm:text-sm text-black03 mt-1">
          Preencha suas informações pessoais para continuar
        </p>
      </div>

      <form className="flex flex-col gap-4 sm:gap-6">
        <div className="grid grid-cols-1">
          <BasicInput
            label="Nome completo"
            {...register("personalInfo.name")}
            error={errors.personalInfo?.name?.message as string}
            placeholder="Digite seu nome completo"
          />
        </div>

        <div className="grid grid-cols-1">
          <BasicInput
            label="E-mail"
            type="email"
            {...register("personalInfo.email")}
            error={errors.personalInfo?.email?.message as string}
            placeholder="email@exemplo.com"
          />
        </div>

        <div className="flex flex-col gap-4 sm:flex-row sm:gap-4">
          <div className="w-full sm:w-auto">
            <BasicInput
              label="Data de nascimento"
              type="date"
              className="w-40 sm:w-40"
              labelClass="w-44 sm:w-44"
              {...register("personalInfo.birthDate")}
              error={errors.personalInfo?.birthDate?.message as string}
              placeholder="DD/MM/AAAA"
            />
          </div>

          <div className="w-full sm:flex-1">
            <BasicInput
              label="Telefone"
              {...register("personalInfo.phone")}
              error={errors.personalInfo?.phone?.message as string}
              placeholder="(00) 00000-0000"
              className="w-full"
              onInput={phoneMask}
            />
          </div>
        </div>

        <div className="grid grid-cols-1">
          <BasicInput
            label="Instagram"
            {...register("personalInfo.instagram")}
            error={errors.personalInfo?.instagram?.message as string}
            placeholder="@seu_usuario"
          />
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <BasicInput
            label="CPF"
            {...register("personalInfo.cpf")}
            error={errors.personalInfo?.cpf?.message as string}
            placeholder="000.000.000-00"
            onInput={cpfMask}
          />

          <BasicInput
            label="RG"
            {...register("personalInfo.rg")}
            error={errors.personalInfo?.rg?.message as string}
            placeholder="Digite seu RG"
          />
        </div>

        <Button
          type="button"
          disabled={!isValid}
          onClick={onSubmit}
          className="mt-2 sm:mt-4 h-11 sm:h-12 w-full bg-primary text-white hover:bg-primary/90 text-sm sm:text-base"
        >
          Continuar
        </Button>

        <div className="text-center">
          <Link
            to="/"
            className="text-xs sm:text-sm text-primary transition-colors hover:text-primary/80"
          >
            Voltar para o login
          </Link>
        </div>
      </form>
    </div>
  );
};

export default PersonalInformation;
